import { EMaterialStatus } from '@shelflix/schemas/material/enums';
import { Badge } from '@shelflix/ui-web/components/ui/badge';

interface StatusBadgeProps {
  status: EMaterialStatus;
  className?: string;
}

const STATUS_LABELS: Record<EMaterialStatus, string> = {
  [EMaterialStatus.ACTIVE]: 'Ativo',
  [EMaterialStatus.OPERATIONALONLINE]: 'Ativo',
  [EMaterialStatus.OFFLINE]: 'Offline',
  [EMaterialStatus.MAINTENANCE]: 'Manutenção',
  [EMaterialStatus.STANDBY]: 'Manutenção',
};

const STATUS_COLORS: Record<EMaterialStatus, string> = {
  [EMaterialStatus.ACTIVE]: 'bg-status-active-bg text-status-active hover:bg-status-active-bg',
  [EMaterialStatus.OPERATIONALONLINE]: 'bg-status-active-bg text-status-active hover:bg-status-active-bg',
  [EMaterialStatus.OFFLINE]: 'bg-status-offline-bg text-status-offline hover:bg-status-offline-bg',
  [EMaterialStatus.MAINTENANCE]: 'bg-status-maintenance-bg text-status-maintenance hover:bg-status-maintenance-bg',
  [EMaterialStatus.STANDBY]: 'bg-status-maintenance-bg text-status-maintenance hover:bg-status-maintenance-bg',
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <Badge variant="outline" className={`${STATUS_COLORS[status]} ${className || ''}`}>
      {STATUS_LABELS[status]}
    </Badge>
  );
}

export { STATUS_LABELS, STATUS_COLORS };
